module.exports = new Promise((resolve, reject) => {
      const url = window.__REMOTES__?.["subscriptions"] || "http://localhost:8500/remoteEntry.js";
      const script = document.createElement("script");
      script.src = url;
      script.onload = () => resolve(window["subscriptions"]);
      script.onerror = (e) => reject(new Error("Failed to load remote: subscriptions from " + url));
      document.head.appendChild(script);
    });